export default "__VITE_ASSET__CEve_QW3__"